import { GraphQLErrors } from "@apollo/client/errors";
import { createStandaloneToast } from "@chakra-ui/react";
import { UseFormSetError } from "react-hook-form";
import { ERROR_CODES } from "../constants";
import { ErrorCode } from "../types";

export const setErrorsFromResponse = (
  { graphQLErrors }: { graphQLErrors: GraphQLErrors },
  setError?: UseFormSetError<any>
) => {
  const { toast } = createStandaloneToast({
    defaultOptions: {
      isClosable: true,
      position: "top",
      duration: 5000
    }
  });

  graphQLErrors.forEach(graphQLError => {
    if (graphQLError.path && graphQLError.path.length > 1 && setError) {
      // exclude first element of path because it's name of mutation
      const [, ...pathArr] = graphQLError.path;
      const fieldName = pathArr.join(".");
      setError(fieldName, {
        message:
          typeof ERROR_CODES[graphQLError?.extensions?.code as ErrorCode] ===
          "function"
            ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              ERROR_CODES[graphQLError?.extensions?.code as ErrorCode](
                graphQLError?.extensions
              )
            : ERROR_CODES[graphQLError?.extensions?.code as ErrorCode]
      });
      return;
    }

    if (!toast) {
      return;
    }

    toast({
      status: "error",
      description:
        typeof ERROR_CODES[graphQLError?.extensions?.code as ErrorCode] ===
        "function"
          ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ERROR_CODES[graphQLError?.extensions?.code as ErrorCode](
              graphQLError?.extensions
            ) || "Oops! Something went wrong."
          : ERROR_CODES[graphQLError?.extensions?.code as ErrorCode] ||
            "Oops! Something went wrong."
    });
  });
};
